import * as React from "react";
import styled from "styled-components";
import { RichText, RichTextQuery, RichTextReact } from "wmk-rich-text";
import { NodeImageFields } from "../../../../fragments/nodeImageFields";
import { options } from "../../../blocks/RichText/richTextOptions";

const Wrap = styled.div`
  position: absolute;
  top: 0;
  left: 150vw;
  transition: all 0.3s ease;
  &.active {
    position: relative;
    left: 0;
    transition: all 0.3s ease;
  }
  .gatsby-image-wrapper {
    width: 100%;
    max-width: 90%;
  }
  code {
    color: #ff9200;
  }
  // @media only screen and (max-width: 991px) {
  //   top: 50rem;
  // }
  @media only screen and (max-width: 767px) {
    .p {
      margin: 0 1rem;
    }
    h3 {
      margin: 0 1rem;
    }
  }
`;

export interface SolutionSectionInt {
  leftColumn: RichTextQuery;
  leftColumnAnimatedBackgroundImage?: NodeImageFields;
  leftColumnWidth: number;
  rightColumn: RichTextQuery;
  rightColumnAnimatedBackgroundImage?: NodeImageFields;
  rightColumnWidth: number;
  secondaryTextColor: string;
  stackOrder: "Right Column on top" | "Left Column on top";
  title: string;
  whiteText: boolean;
}

const SolutionsSection = ({
  solution,
  currSol,
  i,
}: {
  solution: SolutionSectionInt;
  currSol: number;
  i: number;
}) => {
  // console.log('solution: ', solution);
  const { leftColumn, rightColumn, stackOrder } = solution;
  const imageRichText = stackOrder.includes("Right")
    ? new RichText(rightColumn)
    : new RichText(leftColumn);
  const copyRichText = stackOrder.includes("Left")
    ? new RichText(rightColumn)
    : new RichText(leftColumn);
  return (
    <Wrap className={currSol === i ? "active" : ""}>
      <RichTextReact content={imageRichText} options={options} />
      <RichTextReact content={copyRichText} options={options} />
    </Wrap>
  );
};

export default SolutionsSection;
